import http from '../util/axios'
import config from '../../config/endpoints.js'
import moment from 'moment'
//  Default BASE API URL
const API_URL = config.oh_url
const CH_URL = config.ch_url
const CP_URL = config.cp_url
/**
 * @description Api Service Module
 * @author Fahid Mohamamd
 * @date 21-12-2018
 */
const API = {
   getStaticData: function (param, uid, callback) {
      let requestData = { "mtype": param }
      if (uid) { requestData.utid = uid }
      http.post(API_URL + '/general/getStaticData', requestData).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000) {
            if (typeof data === 'object') {
               responseObject.data = data
            }
         }
         return callback(responseObject)
      })
   },

   updateStatus: function (param, callback) {
      http.post(API_URL + '/general/updateStatus', param).then(response => {
         return callback(response)
      })
   },
   assignService: function (param, callback) {
      http.post(CP_URL + '/v1/job/assign', param).then(response => {
         return callback(response)
      })
   },
   reAssignService: function (param, callback) {
      http.post(CP_URL + '/v1/job/reassign', param).then(response => {
         return callback(response)
      })
   },
   allCaptains: function (callback) {
      http.get(CP_URL + '/v1/getAllCaps').then(response => {
         return callback(response)
      })
   },
   getScEmpName: function (param, callback) {
      http.post(API_URL + '/hms/employee/select', param).then(response => {
         return callback(response)
      })

   },
   getSchedules: function (requestData, callback) {
      http.post(API_URL + '/schedule/get/docphy', requestData).then(response => {
         return callback(response)
      })

   },
   getnlSchedules: function (requestData, callback) {
      http.post(API_URL + '/schedule/get/nlt', requestData).then(response => {
         return callback(response)
      })
   },
   saveEmployeeData: function (requestData, callback) {
      //  let requestData = { "commonData": param }
      http.post(API_URL + '/hms/employee/add', requestData).then(response => {
         return callback(response)
      })
   },
   updateEmployee: function (requestData, callback) {
      http.post(API_URL + '/hms/employee/update', requestData).then(response => {
         return callback(response)
      })
   },
   getEmployees: function (param, filterdata, callback) {
      let requestData = {
         "params": {
            "utid": param.type,
            "page": param.value,
            "limit": 5,
            "query": {
               "ph": filterdata.mob ? filterdata.mob: "",
               "email": filterdata.email ? filterdata.email: ""
            },
            "params": {
               "dept_id": filterdata.dep ? filterdata.dep: "" ,
               "name": filterdata.nm ? filterdata.nm: ""
            }
         }
      }
      http.post(API_URL + '/hms/employee/list', requestData).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000) {
            if (typeof data === 'object') {
               responseObject.data = data
            }
         }
         return callback(responseObject)
      })
   },
   getEmployeeById: function (param, callback) {
      let requestData = {
         "uid": param.id,
         "utid": param.ut
      }
      http.post(API_URL + '/hms/employee/id', requestData).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000 && _.isObject(data)) {
            let commonData = data.commonData ? data.commonData : data,
               empSpecData = data.empSpecificData ? data.empSpecificData : {};
            /* if (!empSpecData['exp']) {
               empSpecData['exp'] = { 'val': 0, 'dura_type': "Years" }
            } else {
               empSpecData['exp'] = { 'val': empSpecData['exp'], 'dura_type': "Years" }
            } */
            //  Need to clean the response
            _.assign(commonData, empSpecData)
            // Bind final object
            responseObject.data = commonData
         }
         return callback(responseObject)
      })
   },
   getPatients: function (param, callback) {
      let requestData = {
         "params": {
            "eid": param.eid
         }
      }
      http.post(API_URL + '/hms/getPatientsList', requestData).then(response => {
         return callback(response)
      })
   },
   getDashboard: function (params, callback) {
      http.post(API_URL + '/hms/dashboard', params).then(response => {
         callback(response)
      })
         .catch(err => {
            callback(err)
         })
   },
   getAppoitments: function (param, filterdata, page, callback) {
      let requestData = {
         "page": page,
         "limit": 12,
         "query": {
            //"utid": param.employee,
            //"stid": param.srtype,
            "srvc_com":param.srvc_com,
            "status": param.status,
            "from": param.from,
            "to": param.to,
            "booking_status": filterdata.booking_status,
            "service": param.service,
            "slot": param.slot,
            referral: param.referral
         },
         "params": {
            "apnt_id": filterdata.app,
            "ph": filterdata.ph,
            "email": filterdata.email,
            "pat_nm": filterdata.pat_nm
         }
      }
      http.post(API_URL + '/hms/appointment/list', requestData).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000) {
            responseObject.data = data
         }
         return callback(responseObject)
      })
   },
   cancelAppoitnment: function (param, callback) {
      let requestData = {
         "apnt_id": param,
         "status": "5"
      }
      http.post(API_URL + '/hms/appointment/updateStatus', requestData).then(response => {
         return callback(response)
      })
   },
   getMasters: function (param, callback) {
      http.post(API_URL + '/hms/master/list', param).then(response => {
         return callback(response)
      })
   },
   getSetting: function (callback) {
      http.get(API_URL + '/hms/settings/getAppSetting').then(response => {
         return callback(response)
      })
   },
   getAppointmentSettings: function (callback) {
      http.post(API_URL + '/hms/settings/get').then(response => {
         return callback(response)
      })
   },
   saveAppointments: function (param, callback) {
      let requestData = {
         "params": {
            // "auto_conf_apt": param.confirm_online,
            "srvc": {
               "1": {
                  "ST0": {
                     "dur": param.defualt_home_dur,
                     "fee": {
                        "val": param.defualt_home_fee,
                        "curr": "SAR"
                     }
                  },
                  "ST1": {
                     "dur": param.defualt_video_dur,
                     "fee": {
                        "val": param.defualt_video_fee,
                        "curr": "SAR"
                     }
                  },
                  "ST2": {
                     "dur": param.defualt_chat_dur,
                     "fee": {
                        "val": param.defualt_chat_fee,
                        "curr": "SAR"
                     }
                  },
                  /*  "ST3": {
                      "dur": param.n_duration,
                      "fee": {
                         "val": param.n_employee_fee,
                         "curr": "SAR"
                     }
                    } */
               },
               "2": {
                  "ST0": {
                     "dur": param.p_defualt_home_dur,
                     "fee": {
                        "val": param.p_defualt_home_fee,
                        "curr": "SAR"
                     }
                  },
               },
               "3": {
                  "ST0": {
                     "dur": param.nurse_homr_dur,
                     "fee": {
                        "val": param.nurse_hm_fee,
                        "curr": "SAR"
                     },
                     "min_fee": param.min_nursefee,
                     "buffer_time": param.nurse_buffertime
                  },

               },
               "4": {
                  "ST0": {
                     "dur": param.lab_homr_dur,
                     "fee": {
                        "val": param.lab_hm_fee,
                        "curr": "SAR"
                     },
                     "min_fee": param.min_labfee,
                     "buffer_time": param.lab_buffertime
                  },

               }
            }
         }
      }
      http.post(API_URL + '/hms/settings/addServiceTypeConfig', requestData).then(response => {
         return callback(response)
      })
   },

   savesetting: function (param, callback) {
      let requestData = {
         "app_title": param.app_title,
         "email": param.email,
         "ph": param.ph,
         "pc": param.pc,
         "desc": {
            "en": param.desc.en,
            "ar": param.desc.ar,
         },
         "fav_icon": {
            "file_nm": "favicon",
            "url": param.profilePic
         },
         "logo": {
            "file_nm": "logo",
            "url": param.fav
         },
         "add": param.add,
         "copy_rts": param.copy_rts,
         "twitter": param.twitter,
         "facebook": param.facebook,
         "instagram": param.instagram,
         "google_plus": param.google_plus,
         "img": param.img,
         "lat": param.lat,
         "lon": param.lon,
         "loc": param.loc
      }
      http.post(API_URL + '/hms/settings/addAppSetting', requestData).then(response => {
         return callback(response)
      })
   },
   // get patient list at add docs filter
   getPlist: function (param, callback) {
      let requestData = {
         "query": {
            "apnt_id": param.app_id,
            "pid": param.pid,
            "stid": param.stid,
            "ph": param.mobile
         },
         "params": {
            "pat_nm": param.pname
         }
      }
      http.post(API_URL + '/hms/casestudy/filter', requestData).then(response => {
         return callback(response)
      })
   },
   // get appointments at doc list
   getApps: function (page, filterdata, callback) {
      let requestData = {
         "limit": 10,
         "page": page,
         "params": {
            "apnt_id": filterdata.apnt_id,
            "pid": filterdata.pid,
            "date": filterdata.date,
            "stid": filterdata.stid,
            "pat_nm": filterdata.pat_nm,
            "emp_nm": filterdata.emp_nm,
            "utid": filterdata.utid,
            "ph": filterdata.ph,
            "natid":  filterdata.natid
         }
      }
      http.post(API_URL + '/hms/casestudy/docsList', requestData).then(response => {
         return callback(response)
      })
   },
   addLabtechTest: function (param, callback) {

      http.post(API_URL + '/hms/tasks/addTests', param).then(response => {
         return callback(response)
      })
   },
   addTask: function (param, callback) {
      http.post(API_URL + '/hms/tasks/addNurseTasks', param).then(response => {
         return callback(response)
      })
   },
   getTrests: function (param, callback) {
      http.post(API_URL + '/hms/tasks/getMasters', param).then(response => {
         return callback(response)
      })
   },
   addTreatment: function (param, callback) {
      let requestData = param
      http.post(API_URL + '/hms/tasks/addTreatments', requestData).then(response => {
         return callback(response)
      })
   },
   getTests: function (param, page, callback) {
      switch (param.employee) {
         case 'Test':
            this.requestData = {
               "params": {
                  "utid": "4",
                  "stid": param.srtype,
                  "type": param.type
               },
               "meta": {
                  "page": page,
                  "limit": 20
               },
               "query": {
               }
            }
            break;

      }
      http.post(API_URL + '/hms/tasks/get', this.requestData).then(response => {
         return callback(response)
      })
   },
   addSerive: function (param, callback) {
      let requestData = { param }
      http.post(API_URL + '/hms/tasks/addPackages', param).then(response => {
         return callback(response)
      })
   },
   getmasterpackage: function (param, callback) {
      let requestData = {
         "pkg_id": param
      }
      http.post(API_URL + '/hms/tasks/getTestsforPackages', requestData).then(response => {
         return callback(response)
      })

   },
   // get case study doc
   getDocs: function (requestData, callback) {
      http.post(API_URL + '/hms/casestudy/doc', requestData).then(response => {

         return callback(response)
      })
   },
   updateDepartments: function (param, callback) {
      let requestData = {
         "mtype": 0,
         "dept_id": param.id,
         "active": param.status
      }
      http.post(API_URL + '/hms/master/update', requestData).then(response => {

         return callback(response)
      })
   },
   updateTestsPackage: function (param, callback) {
      let requestData = param
      http.post(API_URL + '/hms/tasks/updateTestsAndPackages', requestData).then(response => {
         return callback(response)
      })
   },
   updateTasks: function (param, callback) {
      let requestData = param
      http.post(API_URL + '/hms/tasks/updateNurseTasks', requestData).then(response => {
         return callback(response)
      })
   },
   updateTreat: function (param, callback) {
      let requestData = param
      http.post(API_URL + '/hms/tasks/updateTreatments', requestData).then(response => {
         return callback(response)
      })
   },
   updateDoc: function (caseData, appid, utid, soapDet, callback) {
      let requestData;
      if (caseData.multi_patient) {
         requestData = {
            apnt_id: appid, // appointment id
            utid:utid,
            prd_id: caseData.prd_id,
            // pid: caseData.pid, // patient id
            // reason: caseData.reason, // reason
            multi_patient: caseData.multi_patient, // checking multi-patient appoint or not
            // summary: caseData.summary,
            t_cmpd: caseData.t_cmpd,
            complete: caseData.complete,
            booking_details: caseData.booking_details,
            soapDet:soapDet
         }
      } else {
         requestData = {
            apnt_id: appid, // appointment id
            utid:utid,
            pid: caseData.pid, // patient id
            reason: caseData.reason, // reason
            multi_patient: caseData.multi_patient, // checking multi-patient appoint or not
            ill_dur: {
               val: caseData.ill_dur.val,
               type: caseData.ill_dur.type
            },
            med_his_id: caseData.med_his_id,
            oth_med_his: caseData.oth_med_his,
            symptoms: caseData.symptoms,
            oth_symp: caseData.oth_symp,
            drug_his: caseData.drug_his,
            allergies: caseData.allergies,
            summary: caseData.summary,
            treatment_plan: caseData.treatment_plan,
            pat_inst: caseData.pat_inst,
            radi_exam: caseData.radi_exam,
            lab_test: caseData.lab_test,
            other_invest: caseData.other_invest,
            bas_treat: caseData.bas_treat,
            adv_treat: caseData.adv_treat,
            lab_tests: caseData.lab_tests,
            lab_packs: caseData.lab_packs,
            lab_reps: caseData.lab_reps,
            nurse_task: caseData.nurse_task,
            t_cmpd: caseData.t_cmpd,
            complete: caseData.complete,
            rslt_vals: caseData.rslt_vals,
            trvl_cert:caseData.trvl_cert,
            clctn_sts:caseData.clctn_sts,
            invsts:caseData.invsts
         }
      }
      if (caseData.prd_id) {
         requestData["prd_id"] = caseData.prd_id;
         requestData["reason"] = caseData.reason || "";
      }
      http.post(API_URL + '/hms/casestudy/save', requestData).then(response => {
         return callback(response)
      })
   },
   addMaster: function (param, callback) {
      let requestData = param

      http.post(API_URL + '/hms/master/addMaster', requestData).then(response => {
         return callback(response)
      })
   },
   getMasterService: function (param, callback) {
      http.post(API_URL + '/hms/master/getMaster', param).then(response => {
         return callback(response)
      })
   },
   getMasterServices: function (param, callback) {
      http.post(API_URL + '/hms/tasks/getServiceTypeList ', param).then(response => {
         return callback(response)
      })
   },
   updatemasterServices: function (param, callback) {
      http.post(API_URL + '/hms/master/updateExcluded', param).then(response => {
         return callback(response)
      })
   },
   getMasterDD: function (param, callback) {
      http.post(API_URL + '/hms/master/masterListForD', param).then(response => {
         return callback(response)
      })
   },
   getTreatments: function (param, callback) {
      http.post(API_URL + '/hms/tasks/getTreatments', param).then(response => {
         return callback(response)
      })
   },
   getServices: function (param, callback) {
      http.post(API_URL + '/hms/tasks/getServiceTypeList', param).then(response => {
         return callback(response)
      })
   },
   getTestForPackages: function (callback) {
      http.post(API_URL + '/hms/master/getTestsforPackages').then(response => {
         return callback(response)
      })
   },
   addSchedule: function (data, uid, utid, duration, multi_slot ,callback) {
      let requestData = {
         "uid": uid,
         "utid": utid,
         "slots": data
      }
      if(duration && multi_slot=='true') requestData['duration'] = duration
      http.post(API_URL + '/schedule/add/doc ', requestData).then(response => {
         return callback(response)
      })
   },
   addnlSchedule: function (param, data, vld_frm, currentdate, callback) {
      let requestData = {
         "params": {
            "utid": param,
            "slots": data,
            'vld_frm':vld_frm || currentdate
         }
      }
      http.post(API_URL + '/schedule/add/nlt', requestData).then(response => {
         return callback(response)
      })
   },
   privileges: (callback) => {
      http.post(API_URL + '/hms/privileges/list').then(response => {
         if (response.data) {
            return callback(response.data)
         } else {
            return callback(null)
         }
      })
   },
   addprivileges: function (param, callback) {
      http.post(API_URL + '/hms/privileges/add', param).then(response => {
         return callback(response)
      })
   },
   getprivileges: function (param, callback) {
      http.post(API_URL + '/hms/privileges/roleList', param).then(response => {
         return callback(response)
      })
   },
   getprivilegesbyId: function (param, callback) {
      http.post(API_URL + '/hms/privileges/getRoleById', param).then(response => {
         return callback(response)
      })
   },
   updateprivileges: function (param, callback) {
      http.post(API_URL + '/hms/privileges/update', param).then(response => {
         return callback(response)
      })
   },
   getdefaultDuration: function (param, callback) {
      http.post(API_URL + '/schedule/getSlotsDuration', param).then(response => {
         return callback(response)
      })
   },
   forgotpwd: function (param, callback) {
      http.post(API_URL + '/hms/forgotPassword', param).then(response => {
         return callback(response)
      })
   },
   validateacnt: function (param, callback) {
      http.post(API_URL + '/hms/validateAccount', param).then(response => {
         return callback(response)
      })
   },
   resetpassword: function (param, callback) {
      http.post(API_URL + '/hms/updateAccount', param).then(response => {
         return callback(response)
      })
   },
   getAccountslist: function (param, callback) {
      http.post(API_URL + '/hms/accounts/list', param).then(response => {
         return callback(response)
      })
   },
   getBillData: function (param, callback) {
      http.post(API_URL + '/hms/accounts/view', param).then(response => {
         return callback(response)
      })
   },
   getInvoice: function (param, callback) {
      http.post(API_URL + '/hms/accounts/invoice', param).then(response => {
         return callback(response)
      })
   },
   getLevelData: function (param, callback) {
      http.post(CH_URL + '/settings/getVCData', param).then(response => {
         return callback(response)
      })
   },
   getGeneralSettings: function (callback) {
      http.get(CH_URL + '/settings/getVCConsultations').then(response => {
         return callback(response)
      })
   },
   getMasterPackages: function (param, callback) {
      http.post(API_URL + '/hms/master/getMasterPackages', param).then(response => {
         return callback(response)
      })
   },
   updateExcludedPackges: function (param, callback) {
      http.post(API_URL + '/hms/master/updateExcludedPackges', param).then(response => {
         return callback(response)
      })
   },
   masterListForPackages: function (callback) {
      http.post(API_URL + '/hms/master/masterListForPackages').then(response => {
         return callback(response)
      })
   },
   getPckagesById: function (param, callback) {
      http.post(API_URL + '/hms/tasks/getPackagesById', param).then(response => {
         return callback(response)
      })
   },
   updatepassword: function (param, callback) {
      http.post(API_URL + '/hms/employee/updatePassword', param).then(response => {
         return callback(response)
      })
   },
   getAppointmentbyId: function (param, callback) {
      http.post(API_URL + '/hms/appointment/id', param).then(response => {
         return callback(response)
      })
   },
   saveEditAppointment: function (param, callback) {
      http.post(API_URL + '/hms/appointment/saveSendOut', param).then(response => {
         return callback(response)
      })
   },
   getAvailableStaff: function (param, callback) {
      http.post(API_URL + '/hms/appointment/v1/getAvailbleStaff', param).then(response => {
         return callback(response)
      })
   },
   assignappointment: function (param, callback) {
      http.post(API_URL + '/hms/appointment/assignAppointment', param).then(response => {
         return callback(response)
      })
   },
   getNursepackages: function (param, callback) {
      http.post(API_URL + '/hms/packages/TasksList', param).then(response => {
         return callback(response)
      })
   },
   getLabtechpackages: function (param, callback) {
      http.post(API_URL + '/hms/packages/packagesList', param).then(response => {
         return callback(response)
      })
   },
   getpackagedetails: function (param, callback) {
      http.post(API_URL + '/hms/packages/getPackagesDetails', param).then(response => {
         return callback(response)
      })
   },
   updatepackageStatus: function (param, callback) {
      http.post(API_URL + '/hms/master/updateExcluded', param).then(response => {
         return callback(response)
      })
   },
   addNurseTaskfee: function (param, callback) {
      http.post(API_URL + '/hms/packages/addNurseTaskFee', param).then(response => {
         return callback(response)
      })
   },
   getTestsForPackages: function (param, callback) {
      http.post(API_URL + '/hms/packages/getTestsForPackages', param).then(response => {
         return callback(response)
      })
   },
   getInstrucitonsforTests: function (param, callback) {
      http.post(API_URL + '/hms/packages/getInstructionsforTests', param).then(response => {
         return callback(response)
      })
   },
   updateLabtechpackage: function (param, callback) {
      http.post(API_URL + '/hms/packages/updateLabtechPackages', param).then(response => {
         return callback(response)
      })
   },
   viewCoupon: function (param, callback) {
      http.post(CH_URL + '/coupons/getSingleCoupon', param).then(response => {
         return callback(response)
      })
   },
   couponList: function (param, callback) {
      http.post(CH_URL + '/coupons/list', param).then(response => {
         return callback(response)
      })
   },
   couponHistory: function (param, callback) {
      http.post(CH_URL + '/coupons/history', param).then(response => {
         return callback(response)
      })
   },
   updateCoupon: function (param, callback) {
      http.post(CH_URL + '/coupons/update', param).then(response => {
         return callback(response)
      })
   },
   // get dept list for coupons
   getDeptList: function (param, callback) {
      http.post(CH_URL + '/coupons/getHsptDeptList', param).then(response => {
         return callback(response)
      })
   },
   // get hosp list for coupon
   getHospList: function (param, callback) {
      http.post(CH_URL + '/coupons/getHospList', param).then(response => {
         return callback(response)
      })
   },
   // get doctor list for coupons
   getDoctorList: function (param, callback) {
      http.post(CH_URL + '/coupons/getHospDoctors', param).then(response => {
         return callback(response)
      })
   },
   // get treatment list for Physio coupon
   getTreatmentList: function (param, callback) {
      http.post(CH_URL + '/coupons/getPhysioTreatmentsList', param).then(response => {
         return callback(response)
      })
   },
   // get physitherapists list for coupon
   getPhysioList: function (param, callback) {
      http.post(CH_URL + '/coupons/getPhysioTherapistList', param).then(response => {
         return callback(response)
      })
   },
   // get Nurse Task list for coupon
   getTaskList: function (param, callback) {
      http.post(CH_URL + '/coupons/getNurseTasks', param).then(response => {
         return callback(response)
      })
   },
   // get Lab Test list for coupon
   getTestList: function (param, callback) {
      http.post(CH_URL + '/coupons/getLabTests', param).then(response => {
         return callback(response)
      })
   },
   // get user(patient) list for coupon
   getUserList: function (param, callback) {
      http.post(CH_URL + '/coupons/getSanarUsers', param).then(response => {
         return callback(response)
      })
   },
   createCoupon: function (param, callback) {
      http.post(CH_URL + '/coupons/create', param).then(response => {
         return callback(response)
      })
   },
   getCouponDetails: function (param, callback) {
      http.post(CH_URL + '/coupons/getSingleCoupon', param).then(response => {
         return callback(response)
      })
   },
   updateCoupon: function (param, callback) {
      http.post(CH_URL + '/coupons/update', param).then(response => {
         return callback(response)
      })

   },
   ratingList: function (param, callback) {
      http.post(API_URL + '/rating/list', param).then(response => {
         return callback(response)
      })
   },
   ratingDetails: function (param, callback) {
      http.post(API_URL + '/rating/details', param).then(response => {
         return callback(response)
      })
   },
   childHospital: function (param, callback) {
      http.post(API_URL + '/general/childhospital', param).then(response => {
         return callback(response)
      })
   },
   overAllRating: function (param, callback) {
      http.post(API_URL + '/rating/overallrating', param).then(response => {
         return callback(response)
      })
   },
   getTrackingDetails: function (param, callback) {
      http.post(API_URL + '/sta/info', param).then(response => {
         return callback(response)
      })
   },
   getTaskData: function (param, callback) {
      http.post(API_URL + '/general/getStaticData', param).then(response => {
         return callback(response)
      })
   },
   getMultiSlotPriceConfig: function (param, callback) {
      http.post(CH_URL + '/doctor/multislotPriceConfig', param).then(response => {
         return callback(response)
      })
   },
   getChildHospitals: function (callback) {
      let eid = localStorage.getItem('entityId')
      http.get(API_URL + '/general/getChildHospitals/' + eid).then(response => {
         return callback(response)
      })
   },
   getEmployeeProducts : function(params, callback){
      http.post(API_URL + '/hms/employee/empProducts', params).then(response => {
         return callback(response)
      })
   },
   getDoctorSchedules : function(params, callback){
      http.post(CH_URL + '/schedule/get-emp-session', params).then(response => {
         return callback(response)
      })
   },    
   blockDoctorSchedules : function(params, callback){
      http.post(CH_URL + '/schedule/add-black-sch', params).then(response => {
         return callback(response)
      })
   }, 
   getCustomizeSchedules : function(params, callback){
      http.post(CH_URL + '/schedule/get-custom-date', params).then(response => {
         return callback(response)
      })
   }, 
   saveCustomizeSchedules : function(params, callback){
      http.post(CH_URL + '/schedule/add-calndrsch', params).then(response => {
         return callback(response)
      })
   },
   saveSchedulesData: function (requestData, callback) {
      http.post(CH_URL + '/schedule/add/doc', requestData).then(response => {
         return callback(response)
      })
   } ,
   getBlockedSchedules : function(params, callback){
      http.post(CH_URL + '/schedule/build-calndr', params).then(response => {
         return callback(response)
      })
   }, 
   saveLabNurseSchedules: function (requestData, callback) {
      http.post(CH_URL + '/schedule/add/emp', requestData).then(response => {
         return callback(response)
      })
   },
   getLabDetails: function (callback) {
      http.get(API_URL + '/general/getLabDetails').then(response => {
         return callback(response)
      })
   },
   getTestAndPackage: function (requestData, callback) {
      http.get(API_URL + '/hms/appointment/sendOutReport', requestData).then(response => {
         return callback(response)
      })
   },
   getDoctors: function (callback) {
      http.get(API_URL + '/general/getDoctorList').then(response => {
         return callback(response)
      })
   },
   UnassignEmployee: function (requestData,callback) {
      http.post(API_URL + '/general/employeeUnassign', requestData).then(response => {
         return callback(response)
      })
   },
   medicalProblems: function (param, callback) {
      http.post(CH_URL + '/bupa/medicalProblems', param).then(response => {
         return callback(response)
      })
   },
}
export default API



// WEBPACK FOOTER //
// ./src/services/api.js